var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-nav"},_vm._l((_vm.items),function(item){return _c('div',{key:item.key,staticClass:"page-nav__item",class:item.key === _vm.value ? 'active' : '',on:{"click":function($event){return _vm.$emit('input', item.key)}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }